import React, { useEffect, useState } from "react";
import { Container, Card, Button, Form, ListGroup, Row, Col } from "react-bootstrap";
import { LOCATION_ID, SQUARE_APP_ID } from "../../assets/Constants";

const CheckoutPage = ({ cart, onPaymentSuccess }) => {
  const [payments, setPayments] = useState(null);
  const [card, setCard] = useState(null);
  const [form, setForm] = useState({ name: "", email: "", phone: "" });

  const subtotal = cart.reduce((sum, item) => sum + item.price, 0);
  const gst = subtotal * 0.10;
  const total = subtotal + gst;

  useEffect(() => {
    async function initSquare() {
        if (!window.Square) {
          console.error("Square.js failed to load or not initialized.");
          return;
        }
      
        try {
          const paymentsInstance = await window.Square.payments(
            SQUARE_APP_ID,
            LOCATION_ID
          );
      
          const cardInstance = await paymentsInstance.card();
          await cardInstance.attach("#card-container");
          setPayments(paymentsInstance);
          setCard(cardInstance);
      
          // Apple Pay
          const applePay = await paymentsInstance.applePay();
          if (await applePay.canMakePayment()) {
            await applePay.attach("#apple-pay-button");
          }
      
          // Google Pay
          const googlePay = await paymentsInstance.googlePay();
          if (await googlePay.canMakePayment()) {
            await googlePay.attach("#google-pay-button");
          }
      
          // Afterpay (if enabled)
          const afterpay = await paymentsInstance.afterpayClearpay();
          if (await afterpay.canMakePayment()) {
            await afterpay.attach("#afterpay-button");
          }
        } catch (error) {
          console.error("Error initializing Square payments:", error);
        }
      }
      
    initSquare();
  }, []);

  const handlePayment = async () => {
    if (!form.name || !form.email || !form.phone) {
      alert("Please fill in all form fields.");
      return;
    }

    const result = await card.tokenize();
    if (result.status === "OK") {
      const res = await fetch("/api/process-payment/", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ 
          nonce: result.token, 
          totalAmount: total,
          ...form,
        }),
      });

      const data = await res.json();
      if (data.success) {
        onPaymentSuccess();
      } else {
        alert("Payment failed: " + (data.error || "Please try again."));
      }
    } else {
      alert("Card tokenization failed. Please check your card info.");
    }
  };

  const handleInputChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  return (
    <Container className="py-5">
      <h1 className="text-center mb-4" style={{ color: "#2959A5" }}>Checkout</h1>

      <Row>
        <Col md={6}>
          <Card className="p-4 shadow-sm mb-4">
            <h5 className="mb-3">Your Order</h5>
            <ListGroup variant="flush">
              {cart.map((item, idx) => (
                <ListGroup.Item key={idx} className="d-flex justify-content-between align-items-center">
                  <div>
                    <strong style={{ color: "#2959A5" }}>{item.name}</strong>
                    <div className="text-muted small">{item.tokens} Tokens</div>
                  </div>
                  <div style={{ color: "#EF3E6D" }}>${item.price.toFixed(2)}</div>
                </ListGroup.Item>
              ))}
              <ListGroup.Item className="d-flex justify-content-between">
                <span>Subtotal</span>
                <strong>${subtotal.toFixed(2)}</strong>
              </ListGroup.Item>
              <ListGroup.Item className="d-flex justify-content-between">
                <span>GST (10%)</span>
                <strong>${gst.toFixed(2)}</strong>
              </ListGroup.Item>
              <ListGroup.Item className="d-flex justify-content-between fw-bold">
                <span>Total</span>
                <span style={{ color: "#EF3E6D" }}>${total.toFixed(2)}</span>
              </ListGroup.Item>
            </ListGroup>
          </Card>
        </Col>

        <Col md={6}>
          <Card className="p-4 shadow-sm mb-4">
            <h5 className="mb-3">Billing Details</h5>
            <Form>
              <Form.Group controlId="formName" className="mb-3">
                <Form.Control
                  type="text"
                  name="name"
                  placeholder="Your Name"
                  value={form.name}
                  onChange={handleInputChange}
                />
              </Form.Group>
              <Form.Group controlId="formEmail" className="mb-3">
                <Form.Control
                  type="email"
                  name="email"
                  placeholder="Your Email"
                  value={form.email}
                  onChange={handleInputChange}
                />
              </Form.Group>
              <Form.Group controlId="formPhone" className="mb-3">
                <Form.Control
                  type="tel"
                  name="phone"
                  placeholder="Your Phone"
                  value={form.phone}
                  onChange={handleInputChange}
                />
              </Form.Group>
            </Form>

            <div id="card-container" className="mb-3"></div>

            {/* Alternative payment buttons if enabled */}
            <div id="apple-pay-button" className="mb-2"></div>
            <div id="google-pay-button" className="mb-2"></div>
            <div id="afterpay-button" className="mb-2"></div>

            <Button
              variant="danger"
              className="rounded-pill fw-semibold px-4 w-100"
              style={{ backgroundColor: "#EF3E6D", borderColor: "#EF3E6D" }}
              onClick={handlePayment}
            >
              Pay ${total.toFixed(2)}
            </Button>

            <p className="text-muted text-center mt-2" style={{ fontSize: "0.9rem" }}>
              Secured payment powered by Square
            </p>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default CheckoutPage;
